import { createAction, props } from '@ngrx/store';
import { IHelpDocumentsFromProfile } from '../../admin/countries/countries.models';

export const loadHelpDocuments = createAction('[Header] Load Help Documents');
export const loadHelpDocumentsSuccess = createAction(
  '[Header] Load Help Documents Success',
  props<{ documents: IHelpDocumentsFromProfile[] }>()
);
export const loadHelpDocumentsFailure = createAction(
  '[Header] Load Help Documents Failure'
);
